import type { ReactElement } from 'react';
import { Skeleton } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';
import { useEntityActivities } from '../../features/activity/hooks/useEntityActivities.js';
import type { ActivityEntity } from '../../features/activity/api/activities.client.js';
import { describeActivity } from '../../features/activity/lib/describeActivity.js';
import { ErrorState } from '../../shared/ui/ErrorState.js';
import { EntityHistoryFeed } from './EntityHistoryFeed.js';

export function EntityActivityHistory({
  entity,
  entityId,
}: {
  entity: ActivityEntity;
  entityId: string;
}): ReactElement {
  const { t } = useTranslation();
  const query = useEntityActivities(entity, entityId);
  if (query.isLoading) return <Skeleton active />;
  if (query.isError)
    return (
      <ErrorState
        title={t('crm.entity_detail.load_error')}
        error={query.error}
        onRetry={() => void query.refetch()}
      />
    );
  return (
    <EntityHistoryFeed
      items={(query.data ?? []).map((item) => ({
        id: item.id,
        text: ['project_created', 'project_updated', 'project_deleted'].includes(item.kind)
          ? t('crm.dashboard.activity.kind.' + item.kind)
          : describeActivity(item),
        date: item.occurredAt ?? item.createdAt,
        meta: item.actor,
      }))}
    />
  );
}
